import { render, staticRenderFns } from "./AcademyNoticeRegist.vue?vue&type=template&id=dcb5de5c&scoped=true&lang=pug&"
import script from "./AcademyNoticeRegist.vue?vue&type=script&lang=ts&"
export * from "./AcademyNoticeRegist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb5de5c",
  null
  
)

export default component.exports